import $ from 'jquery';
import eventBus from 'EventBus';
import util from 'util/Util';
import BasePropertyView from 'BasePropertyView';
import formatTemplate from 'properties/theme/tables.ejs';
import themeService from 'ThemeService';
import { pickerCfg } from 'pickerCfg';
import undoService from 'UndoService';
import pageSyncService from 'PageSyncService';
import focusController from 'FocusController';
import Immutable from 'immutable';
import fontService from 'FontService';
class TablesView extends BasePropertyView {

    initialize(opts) {
        super.initialize(opts);

        this.options = opts || {};
        this.template = formatTemplate;
        this.tagName = 'div';
        this.id = opts.el;
        this.selectedColor = 'lightgrey';
        this.unselectedColor = 'transparent';

        this.initializeTextAttributes();

        let defaultStyles = {};

        ['~tableHeaderBgColor', '~tableHeaderBgGradientColor', '~tableRowColor1', 
         '~tableRowColor2', '~tableBgColor', '~tableHeaderTextColor',
         '~tableBorderColor'].forEach(propStyle => {
             defaultStyles[propStyle] = themeService.resolve(propStyle) || themeService.resolveDefaultThemeValue(propStyle);
         }); 

        this.model.set('tableHeaderBgColor', defaultStyles['~tableHeaderBgColor'], { silent: true });
        this.model.set('tableHeaderBgGradientColor',defaultStyles['~tableHeaderBgGradientColor'], { silent: true });
        this.model.set('tableRowColor1', defaultStyles['~tableRowColor1'], { silent: true });
        this.model.set('tableRowColor2', defaultStyles['~tableRowColor2'], { silent: true });
        this.initializeBorderAttributes();
        this.model.set('tableBgColor', defaultStyles['~tableBgColor'], { silent: true });
        this.model.set('tableHeaderTextColor', defaultStyles['~tableHeaderTextColor'], { silent: true });
        this.model.set('tableBorderColor', defaultStyles['~tableBorderColor'], { silent: true });

        this.events = {
            'change input[type=text]': 'updateAttributes',
            'change input[type=color]': 'updateColorAttributes',
            'blur input[type=text]': 'lostFocus',
            'focus input[type=text]': 'getFocus',
            'change select': 'updateSelectAttributes',
            'click .styleSelectorTable': 'updateTextStyleAttributes',
            'click .weightSelectorTable': 'updateTextWeightAttributes'
        };

        // This name known to base claas:
        this.dropdownPropNames = Immutable.Set(
            ['tableHeaderFont', 'tableHeaderFontSize', 'tableBorderStyle', 'tableBorderSize', 'tableBorderRadius']);
 
        return this;
    }

    initializeTextAttributes() {
        this.model.set('tableHeaderTextColor', themeService.resolve('~tableHeaderTextColor'), { silent: true });

        var fontPropTemp = themeService.resolve('~tableHeaderFont');
        if (!fontPropTemp) {
            fontPropTemp = themeService.resolveDefaultThemeValue('~tableHeaderFont');
        } 

        let fontProp = fontPropTemp.split(',');
       
        this.model.set('tableHeaderFont', fontProp[0].trim(), { silent: true });
        this.model.set('tableHeaderFontSize', fontProp[1].trim(), { silent: true });

        if ((fontProp[2] && fontProp[2].toLowerCase().indexOf('bold') > -1) ||
            (fontProp[3] && fontProp[3].toLowerCase().indexOf('bold') > -1)) {
            this.model.set('tableHeaderTextWeight', 'bold', { silent: true });
        } else {
            this.model.set('tableHeaderTextWeight', 'normal', { silent: true });
        }
        if (this.model.get('tableHeaderTextWeight') === 'normal') {
            this.model.set('tableHeaderTextWeightSelection', this.unselectedColor, { silent: true });
        } else {
            this.model.set('tableHeaderTextWeightSelection', this.selectedColor, { silent: true });
        }

        if ((fontProp[2] && fontProp[2].toLowerCase().indexOf('italic') > -1) ||
            (fontProp[3] && fontProp[3].toLowerCase().indexOf('italic') > -1)) {
            this.model.set('tableHeaderTextStyle', 'italic', { silent: true });
        } else {
            this.model.set('tableHeaderTextStyle', 'normal', { silent: true });
        }
        if (this.model.get('tableHeaderTextStyle') === 'normal') {
            this.model.set('tableHeaderTextStyleSelection', this.unselectedColor, { silent: true });
        } else {
            this.model.set('tableHeaderTextStyleSelection', this.selectedColor, { silent: true });
        }

    }

    updateThemeFontAttributes() {
        const themePropArray = [this.model.get('tableHeaderFont'), this.model.get('tableHeaderFontSize'), this.model.get('tableHeaderTextWeight'), this.model.get('tableHeaderTextStyle')];
        themeService._theme['~tableHeaderFont'] = themePropArray.join(',');
    }

    initializeBorderAttributes() {
        this.model.set('tableBorderColor', themeService.resolve('~tableBorderColor'), { silent: true });

        var fontPropTemp = themeService.resolve('~tableBorder');
        if (!fontPropTemp) {
            fontPropTemp = themeService.resolveDefaultThemeValue('~tableBorder');
        }

        let fontProp = fontPropTemp.split(","); 

        this.model.set('tableBorderSize', fontProp[0].trim(), { silent: true });
        this.model.set('tableBorderStyle', fontProp[1].trim().toLowerCase(), { silent: true });
        this.model.set('tableBorderRadius', (fontProp[2] || '0').trim(), { silent: true });
    }

    updateTextStyleAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const oldValue = this.model.get(propName);
        var style = this.model.get(propName);

        if (this.model.get(propName).indexOf('italic') > -1) {
            this.model.set(propName + 'Selection', this.unselectedColor, { silent: true });
            style = 'normal';
        } else {
            this.model.set(propName + 'Selection', this.selectedColor, { silent: true });
            style = 'italic';
        }

        this.model.set(propName, style, { silent: true });
        this.updateThemeFontAttributes();
        eventBus.trigger('TableThemeChange');
        this.render();
        undoService.add({
            undo: () => {
                if (oldValue.indexOf('italic') > -1) {
                    this.model.set(propName + 'Selection', this.selectedColor, { silent: true });
                } else {
                    this.model.set(propName + 'Selection', this.unselectedColor, { silent: true });
                }
                this.model.set(propName, oldValue, { silent: true });
                this.updateThemeFontAttributes();

                //eventBus.trigger('InputThemeChange');
                //this.model.trigger('change', this.model);
                pageSyncService.renderCurrentPageView();
                focusController.switchPropsViews();
            },
            redo: () => {
                if (style.indexOf('italic') > -1) {
                    this.model.set(propName + 'Selection', this.selectedColor, { silent: true });
                } else {
                    this.model.set(propName + 'Selection', this.unselectedColor, { silent: true });
                }
                this.model.set(propName, style, { silent: true });
                this.updateThemeFontAttributes();

                //eventBus.trigger('InputThemeChange');
                //this.model.trigger('change', this.model);
                pageSyncService.renderCurrentPageView();
                focusController.switchPropsViews();
            }
        })
    }

    updateTextWeightAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const oldValue = this.model.get(propName);
        var weight = this.model.get(propName);

        if (this.model.get(propName).indexOf('bold') > -1) {
            this.model.set(propName + 'Selection', this.unselectedColor, { silent: true });
            weight = 'normal';
        } else {
            this.model.set(propName + 'Selection', this.selectedColor, { silent: true });
            weight = 'bold';
        }

        this.model.set(propName, weight, { silent: true });
        this.updateThemeFontAttributes();
        eventBus.trigger('TableThemeChange');
        this.render();
        undoService.add({
            undo: () => {
                if (oldValue.indexOf('bold') > -1) {
                    this.model.set(propName + 'Selection', this.selectedColor, { silent: true });
                } else {
                    this.model.set(propName + 'Selection', this.unselectedColor, { silent: true });
                }
                this.model.set(propName, oldValue, { silent: true });
                this.updateThemeFontAttributes();

                //eventBus.trigger('InputThemeChange');
                //this.model.trigger('change', this.model);
                pageSyncService.renderCurrentPageView();
                focusController.switchPropsViews();
            },
            redo: () => {
                if (weight.indexOf('italic') > -1) {
                    this.model.set(propName + 'Selection', this.selectedColor, { silent: true });
                } else {
                    this.model.set(propName + 'Selection', this.unselectedColor, { silent: true });
                }
                this.model.set(propName, weight, { silent: true });
                this.updateThemeFontAttributes();

                //eventBus.trigger('InputThemeChange');
                //this.model.trigger('change', this.model);
                pageSyncService.renderCurrentPageView();
                focusController.switchPropsViews();
            }
        })

    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;
        const oldPropVal = this.model.get(propName);
        const oldThemeValue = themeService._theme['~' + propName];

        if (util.isValidColorcode(propVal)) {
            let color = this.resolveColor(propVal);
            this.model.set(propName, color, { silent: true });
            themeService._theme['~' + propName] = color;
            $('#' + propName).val(color);
            this.addUndoRedoColorAction(propName, oldThemeValue, oldPropVal, color);
            this.render();
            eventBus.trigger('TableThemeChange');
        }
        else {
            this.render();
        }
    }

    updateColorAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;
        const oldPropVal = this.model.get(propName);
        const oldThemeValue = themeService._theme['~' + propName];

        let color = this.resolveColor(propVal);
        this.model.set(propName, color, { silent: true });
        themeService._theme['~' + propName] = color;
        $('#' + propName).val(color);
        this.addUndoRedoColorAction(propName, oldThemeValue, oldPropVal, color);
        this.render();
        eventBus.trigger('TableThemeChange');
    }

    addUndoRedoColorAction(propName, oldThemeValue, oldPropVal, currentColor) {
        undoService.add({
            undo: () => {
                this.model.set(propName, oldPropVal, { silent: true });
                themeService._theme['~' + propName] = oldThemeValue;
                //eventBus.trigger('InputThemeChange');
                pageSyncService.renderCurrentPageView();
                focusController.switchPropsViews();
                $('#' + propName).val(oldPropVal);
            },
            redo: () => {
                this.model.set(propName, currentColor, { silent: true });
                themeService._theme['~' + propName] = currentColor;
                //eventBus.trigger('InputThemeChange');
                pageSyncService.renderCurrentPageView();
                focusController.switchPropsViews();
                $('#' + propName).val(currentColor);
            }
        })
    }

    updateSelectAttributes(ev, name, val) {
        ev.preventDefault();
        console.log('select update');
        const propName = name || ev.currentTarget.name;
        const propVal = val || ev.currentTarget.value;
        const oldPropVal = this.model.get(propName);


        this.model.set(propName, propVal, { silent: true });
        if (propName === 'tableHeaderFont' || propName === 'tableHeaderFontSize') {
            this.updateThemeFontAttributes();
        } else {
            this.updateThemeBorderAttributes();
        }
        this.render();
        eventBus.trigger('TableThemeChange');
        undoService.add({
            undo: () => {
                this.model.set(propName, oldPropVal, { silent: true });
                if (propName === 'tableHeaderFont' || propName === 'tableHeaderFontSize') {
                    this.updateThemeFontAttributes();
                } else {
                    this.updateThemeBorderAttributes();
                }

                //eventBus.trigger('InputThemeChange');
                pageSyncService.renderCurrentPageView();
                focusController.switchPropsViews();
            },
            redo: () => {
                this.model.set(propName, propVal, { silent: true });
                if (propName === 'tableHeaderFont' || propName === 'tableHeaderFontSize') {
                    this.updateThemeFontAttributes();
                } else {
                    this.updateThemeBorderAttributes();
                }

                pageSyncService.renderCurrentPageView();
                focusController.switchPropsViews();
            }
        })
    }

    updateThemeBorderAttributes() {
        const themePropArray = [this.model.get('tableBorderSize'), this.model.get('tableBorderStyle'), this.model.get('tableBorderRadius')];
        themeService._theme['~tableBorder'] = themePropArray.join(',');
    }


    render() {
        super.render();

        if (this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        util.prepareComboWidget(this.$el, this);

        this.createEditableDropDown('tableHeaderFontSize');
        this.createEditableDropDown('tableBorderSize');
        this.createEditableDropDown('tableBorderRadius');
        
        this.checkBorderDropDown('#tableBorderSize', 'tableBorderStyle');
        this.checkBorderDropDown('#tableBorderRadius', 'tableBorderStyle');

        const fonts = fontService.loadFontsDropDown(false);
        $("#tableHeaderFont").append(fonts);

        //.$('input[type=color]', this.$el).spectrum(pickerCfg);

        // Update via this.dropdownPropNames:
        this.updateForm();
        this.delegateEvents();
        return this;
    }

}

export default TablesView;
